import {ChangeDetectionStrategy, Component, inject, Input, OnChanges, SimpleChanges} from "@angular/core";
import {Store} from "@ngrx/store";
import {Router} from "@angular/router";
import {BehaviorSubject, combineLatest, Observable, of, switchMap} from "rxjs";
import {AlgorithmicDmvActions} from "../store/algorithmic-dmv.actions";
import {selectActiveJobForFundValuation, selectReadyJobForFundValuation} from "../store/algorithmic-dmv.selectors";
import {AlgorithmicDmvJobInfo} from "../generated-sources/api";

@Component({
    selector: "valumize-algorithmic-dmv-status-chip",
    templateUrl: "./algorithmic-dmv-status-chip.component.html",
    styleUrls: ["./algorithmic-dmv-status-chip.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AlgorithmicDmvStatusChipComponent implements OnChanges {

    @Input({required: true}) fundId!: number;
    @Input({required: true}) fundValuationId!: number;

    private readonly store = inject(Store);
    private readonly router = inject(Router);

    private readonly fundId$ = new BehaviorSubject<number | null>(null);
    private readonly fundValuationId$ = new BehaviorSubject<number | null>(null);

    readonly activeJob$: Observable<AlgorithmicDmvJobInfo | undefined> =
        combineLatest([this.fundId$, this.fundValuationId$]).pipe(
            switchMap(([fundId, fundValuationId]) =>
                fundId != null && fundValuationId != null
                    ? this.store.select(selectActiveJobForFundValuation(fundId, fundValuationId))
                    : of(undefined)));

    readonly readyJob$: Observable<AlgorithmicDmvJobInfo | undefined> =
        combineLatest([this.fundId$, this.fundValuationId$]).pipe(
            switchMap(([fundId, fundValuationId]) =>
                fundId != null && fundValuationId != null
                    ? this.store.select(selectReadyJobForFundValuation(fundId, fundValuationId))
                    : of(undefined)));

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["fundValuationId"]) {
            this.fundValuationId$.next(this.fundValuationId ?? null);
        }
        if (changes["fundId"]) {
            this.fundId$.next(this.fundId ?? null);
            if (this.fundId) {
                this.store.dispatch(AlgorithmicDmvActions.loadJobs({fundId: this.fundId}));
            }
        }
    }

    openReview(taskInfoId: number) {
        this.router.navigate(["/algorithmic-dmv", taskInfoId]);
    }
}
